'use client';

import React from 'react';
import Link from 'next/link';
import { Container, Button } from '@mantine/core';
import classes from './ScollablePictureCard.module.scss';
import { useAOS } from '@/src/lib/hooks/useAOS';

export type ScrollablePictureCardSlice = {
    type: 'scrollable-picture-card';
    title?: string;
    description?: string;
    paragraphs?: string[];

    ctaLabel?: string;
    ctaUrl?: string;

    position?: 'left' | 'right';
    className?: string;

    backgroundImageUrl?: string;

    aos?: {
        animation?: string;
        delay?: number;
    };
};

export default function ScrollablePictureCard({ slice }: { slice: ScrollablePictureCardSlice }) {
    useAOS();

    const {
        title = 'Entreprises & CSE',
        description = 'Des ateliers créatifs clé en main pour vos événements.',
        paragraphs = [],
        ctaLabel = 'Demander un devis',
        ctaUrl = '/entreprises',
        position = 'right',
        className,
        backgroundImageUrl,
        aos,
    } = slice;

    return (
        <section className={[classes.section, className].filter(Boolean).join(' ')} data-side={position}>
            {backgroundImageUrl && (
                <div className={classes.bg} aria-hidden="true">
                    <div className={classes.bgImage} style={{ backgroundImage: `url(${backgroundImageUrl})` }} />
                    <div className={classes.bgOverlay} />
                </div>
            )}

            <Container size="xl" className={classes.container}>
                <div
                    className={classes.card}
                    data-aos={aos?.animation ?? 'fade-up'}
                    data-aos-delay={typeof aos?.delay === 'number' ? aos.delay : 0}
                >
                    <header className={classes.header}>
                        <h2 className={classes.title}>{title}</h2>
                        {description && <p className={classes.lead}>{description}</p>}
                    </header>

                    {!!paragraphs?.length && (
                        <div className={classes.body}>
                            {paragraphs.slice(0, 4).map((p, i) => (
                                <p key={i} className={classes.p}>
                                    {p}
                                </p>
                            ))}
                        </div>
                    )}

                    {ctaLabel && ctaUrl && (
                        <div className={classes.footer}>
                            <Button component={Link} href={ctaUrl} className={classes.cta}>
                                {ctaLabel}
                            </Button>
                        </div>
                    )}
                </div>
            </Container>
        </section>
    );
}
